<template>
  <v-container id="registry">
    <v-layout column>
      <v-flex class="display-2 text-xs-center my-5">Registry</v-flex>
      <v-divider insert></v-divider>
      <v-container lg4>
        <v-flex>
          <p class="subheading mt-3">
            We do not think that you need to give us any gifts. Just being able to celebrate
             with you all is the only thing that we want. If you really want to give us
             something, we set up a registry
             <a href="https://www.zola.com/registry/danandanan" target="_blank">here.</a>
          </p>
        </v-flex>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'Registry',
};
</script>

<style scoped></style>
